import "antd/dist/reset.css";
import { Collapse,Descriptions} from "antd";
import React from "react";
import utils from "utils";
import "./SOSSummaryChild.scss";

const { Panel } = Collapse;

const LoopSecondarySummary=(data,heading)=>{
  let heading1 = false;
  Object.entries(data).map(([subKey,headValue])=>{
    if(headValue?.values && headValue?.values.length>0)
    { heading1=true;  }
  })
return(
  <>
  {heading1 && <div style={{margin:"10px",fontWeight:"bold"}}>{heading}</div>}
  
    {Object.entries(data).map(([subKey,subValue],i)=>{
       if(typeof subValue.values=="string" && subValue.values.trim().length>0)
       {return(
        <Descriptions
        bordered
        layout="horizontal"
        column={1}
        labelStyle={{ width: "50%" }}>
       <Descriptions.Item key={i} label={subValue?.label}>
       {subValue.values}
     </Descriptions.Item></Descriptions>)}
       else if(typeof subValue.values=="object")
       {
        let heading2=false;
        Object.entries(subValue.values).map(([subSetKey,heading2Value])=>{
          if(heading2Value?.values && heading2Value?.values.length>0){heading2=true;}
        })
        return(
          <>
          {subValue.title?
          <>
          {heading2 && <div style={{margin:"10px",fontWeight:"bold"}}>{subValue.title}</div>}
           {Object.entries(subValue.values).map(([subSetKey,subSetData],j)=>{
                  if(typeof subSetData.values=="string" && subSetData.values.trim().length>0)
                  {return(
                    <Descriptions
                      bordered
                      layout="horizontal"
                      column={1}
                      labelStyle={{ width: "50%" }}
                    >
                    <Descriptions.Item  key={j} label={subSetData?.label}>
                      {subSetData.values}
                    </Descriptions.Item>
                    </Descriptions>
                  )
                  }
                })}
                </>:null}
                </>
        )
       }
    })}
 
  </>
)
}

const LoopSummary=(data)=>{
  return(
    Object.entries(data).map(([parentKey,parentValue],i)=>{
      if(typeof parentValue.values=="string" && parentValue.values.trim().length>0){
        return(
          <Descriptions
            bordered
            layout="horizontal"
            column={1}
            labelStyle={{ width: "50%" }}
          >
                {parentValue.values.trim().length>0 && (
                  <Descriptions.Item key={i} label={parentValue?.label}>
                    {parentValue.values}
                  </Descriptions.Item>
                )}
          </Descriptions>
        )
      }
      if(typeof parentValue.values=="object")
      {
        return(LoopSecondarySummary(parentValue.values,parentValue.title))
      }
     
    }))
}

const PSTSummaryChild = (props) => {
  return (
    <>
      {props.data?.completion_date  ? (
        <Collapse
          style={{ overflowY: "auto" }}
          bordered={false}
          expandIconPosition="start"
          ghost={true}
          className="mhe-list-container"
        >
          <Panel
            header={
              <div>
                {utils.FormatDate(props?.data?.completion_date, "DATE_14")},{" "}
                {utils.FormatDate(props?.data?.completion_date, "TIME_1")}
              </div>
            }
            extra={utils.FirstNameLastName(utils.salutationPrefixName(props?.data?.doctor_salutation, utils.getDisplayName(props?.data?.consultation_doctor, props?.data?.doctor_last_name)), "250px")}
            key="1"
          >
            {LoopSummary(props.data.values)}
          </Panel>
        </Collapse>
      ) : null}
    </>
   
  );
};

export default PSTSummaryChild;
